import styled, { keyframes } from 'styled-components';

const EaseIn = keyframes`
  from{ opacity:0; }
  to{ opacity:1; }
`;

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
    margin-top: 52px;
  }

  .TitleContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media only screen and (max-width: 1180px) {
      justify-content: center;
      align-self: center;
      align-items: center;
      margin-top: -40px;
    }
  }

  .CardContainer1 {
    margin-top: 20px;
    @media only screen and (max-width: 1180px) {
      margin-top: 100px;
    }
    @media only screen and (max-width: 945px) {
      margin-top: 180px;
    }
    @media only screen and (max-width: 785px) {
      margin-top: 220px;
    }
    @media only screen and (max-width: 768px) {
      margin-top: 120px;
    }
    @media only screen and (max-width: 767px) {
      margin-top: 220px;
    }
    .infocontainer {
      @media only screen and (max-width: 567px) {
        margin-top: 120px;
      }
    }
    .infoitem {
      @media only screen and (max-width: 767px) {
        margin-top: 20px;
      }
    }
  }

  .CardContainer {
    margin-top: 20px;
    .infoitem {
      @media only screen and (max-width: 767px) {
        margin-top: 20px;
      }
    }
  }

  .buttonsContainer {
    margin-top: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    button,
    a {
      width: 50%;
      z-index: 9999999;
      margin-bottom: 31px;
    }
  }

  .buttons {
    display: flex;
    button {
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;

      &:hover {
        background: #b14729;
      }
    }
  }

  .tarifaOptions {
    transition: all 0.3s ease;
    animation: ${EaseIn} 0.5s;
  }

  .cancel {
    border: 2px solid var(--purple);
    background: transparent;
    color: var(--purple);
    transition: all 0.3s ease;
    margin-right: 10px;
    font-family: 'Source Sans Pro' sans-serif;
    font-size: 1rem;
    font-weight: 400;
    height: 40px;
    padding: 0 3rem;
    padding: 0 1rem;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: var(--purple);
      color: var(--white);
    }
  }
`;
export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;
  color: var(--orange);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 1180px) {
    text-align: center;
    flex-direction: column-reverse;
  }
`;

export const SubTitle = styled.p`
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;

  color: #000000;

  @media only screen and (max-width: 1180px) {
    text-align: center;
  }
`;

export const Card = styled.div`
  display: flex;
  background: #ebf1f4;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  padding: 35px;

  @media only screen and (max-width: 1255px) {
    flex-direction: column;
  }

  .CardTitle {
    width: 18%;
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 37px;
    color: #452359;
    @media only screen and (max-width: 1255px) {
      width: 100%;
    }
  }

  .CardForm {
    width: 100%;
  }
`;
